import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/ClubPage.css";

// ✅ Utility function for date formatting
const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return "Unknown Date";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const AchievementsSlider = ({ clubData }) => {
    if (!clubData || !clubData.participations) {
        console.log("🚀 Club data or participations not found, loading...");
        return <p>Loading achievements...</p>;
    }

    // const filteredAchievements = clubData.participations
    //     .filter(event => ["Johan", "Naib Johan", "Ketiga"].includes(event.achievement))
    //     .filter((event, index, self) => self.findIndex(e => e.achievement === event.achievement && e.name === event.name) === index);

    const filteredAchievements = clubData.participations
        .filter(event => event.isAchievement === true)
        .filter((event, index, self) =>
            self.findIndex(e => e.name === event.name && e.achievement === event.achievement) === index
        );

    // **Fix: Ensure slider works even if only 1 item exists**
    const sliderSettings = {
        dots: true,
        infinite: filteredAchievements.length > 1, // Disable infinite scroll if only 1 item
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: filteredAchievements.length > 1, // Disable autoplay if only 1 item
        autoplaySpeed: 3000,
        centerMode: false,
    };

    return (
        <div className="achievements-container">
            {filteredAchievements.length > 0 ? (
                <Slider {...sliderSettings} className="achievements-slider">
                    {filteredAchievements.map((event, index) => (
                        <div key={index} className="achievement-card">
                            {event.media?.length > 0 && event.media[0].startsWith("http") && (
                                <img src={event.media[0]} alt={event.name} className="achievement-image" />
                            )}
                            <h3>{event.achievement}</h3>
                            <p>{event.name}</p>
                            <p>{event.location}</p>
                            <p>{formatDate(event.date_start)} to {formatDate(event.date_end)}</p>
                        </div>
                    ))}
                </Slider>
            ) : (
                <p>No achievements found.</p>
            )}
        </div>
    );
};

export default AchievementsSlider;
